export default {
  state: {
    parameterization: {},
  },

  getters: {
    getParameterization: (state) => state.parameterization,
  },

  mutations: {
    setParameterization(state, data) {
      const isUpdate = data && data.id !== undefined;

      const module_doc = isUpdate ? data.modules.includes(1) : false;
      const module_vig = isUpdate ? data.modules.includes(2) : false;
      const module_vig_test = isUpdate ? data.health_centers.length > 0 : false;
      const module_vig_vaccine = isUpdate ? data.vaccines.length > 0 : false;
      const radios_doc = isUpdate
        ? data.medical_centers.length > 0
          ? "post"
          : "unity"
        : "unity";

      state.parameterization = {
        id: isUpdate ? data.id : "",
        name: isUpdate ? data.name : "",
        year: isUpdate ? Number(data.year) : "",
        date_start: isUpdate ? data.date_start : "",
        date_end: isUpdate ? data.date_end : "",
        counties: isUpdate ? data.counties : [],
        origins: isUpdate ? data.origins : [],
        unity: isUpdate ? data.unity : [],
        desserts: isUpdate ? data.health_centers : [],
        health_centers: isUpdate ? data.health_centers : [],
        vaccines: isUpdate ? data.vaccines : [],
        module_vig,
        module_doc,
        module_vig_test,
        module_vig_vaccine,
        posto_vig: "",
        posto_doc: isUpdate ? data.medical_centers : [],
        origin_vig: "",
        radios_doc,
      };
    },
  },

  actions: {
    changeParameterization(context, data) {
      context.commit("setParameterization", data);
    },
  },
};
